import { useState } from "react";

import { Box, Grid, Switch, TextField, Typography } from "@mui/material";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { FormHiddenField } from "../../../../components/forms";
import { DRAWER_FORM_GRID_SPACING } from "../../../../lib/ui/dialogFormLayout";
import { useTranslation } from "react-i18next";

const CreateMailFilterDialogBody = (_item: any) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState(true);

  return (
    <DrawerForm>
      <DrawerFormSection title={t("form.filter")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              autoFocus
              required
              fullWidth
              id="name"
              name="name"
              label={t("common.name")}
              variant="outlined"
              size="small"
              placeholder="e.g. Critical Alert Mail"
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              id="description"
              name="description"
              label={t("common.description")}
              variant="outlined"
              size="small"
              placeholder={t("common.optional")}
            />
          </Grid>
          <Grid size={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, minHeight: 40 }}>
              <Switch size="small" checked={status} onChange={(e) => setStatus(e.target.checked)} />
              <Typography variant="body2">{status ? "Active" : "Inactive"}</Typography>
              <FormHiddenField name="status" value={status ? "true" : "false"} />
            </Box>
          </Grid>
        </Grid>
      </DrawerFormSection>

      <DrawerFormSection title={t("form.match")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="subject"
              name="subject"
              label={t("mailFilters.subject")}
              variant="outlined"
              size="small"
              placeholder={t("form.mailSubject")}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="body"
              name="body"
              label={t("mailFilters.body")}
              multiline
              rows={5}
              variant="outlined"
              size="small"
              placeholder={t("form.filterText")}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default CreateMailFilterDialogBody;
